import { Suspense, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import WrappedRoutes from "../routes/WrappedRoutes";
import ToastNotification from "../common/ToastNotification";
import { _init } from "../utils/socketService";
import { getDeviceData } from "../utils/utils";
import MobileRestricationComponent from "./MobileRestricationComponent";
import Mixpanel from "mixpanel-browser";
import constant from "../constants/constants";
import TagManager from 'react-gtm-module';

Mixpanel.init(constant.mixpanelToken);

const Main = () => {

  // useEffect(() => {
  //   _init();
  // }, []);

  useEffect(() => {
    async function GTMTracking() {
      const tagManagerArgs = {
        gtmId: 'GTM-N78JZTT'
      }
      await process.env.REACT_APP_ENVIRONMENT == "LIVE" && TagManager.initialize(tagManagerArgs);
    }
    GTMTracking();
  }, []);

  let deviceType = getDeviceData();
  return (
    <>
      <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
        <Suspense
          fallback={
            <div className="d-flex justify-content-center">
              {/* <Loading /> */}
            </div>
          }
        >
          {deviceType?.device_type === 'Mobile' ?
            <Routes>
              <Route path="*" element={<MobileRestricationComponent />} />
            </Routes>
            :
            <WrappedRoutes />}
        </Suspense>
        <ToastNotification />
      </BrowserRouter>
    </>
  );
};

export default Main;